(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/gift-form.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/gift-form.js');
"use strict";


const Form = svs.ui.reactForm.Form;
const Cart = svs.tickets_giftshop.gift.giftform.cart.Cart;
const _svs$tickets_giftshop = svs.tickets_giftshop.gift.giftform.components,
  PersonalInfo = _svs$tickets_giftshop.PersonalInfo,
  ReceiverTypeInfo = _svs$tickets_giftshop.ReceiverTypeInfo;
const DateSelector = svs.tickets_giftshop.gift.giftform.date_selector.DateSelector;
const _svs$tickets_giftshop2 = svs.tickets_giftshop.constants.names,
  PHONE = _svs$tickets_giftshop2.PHONE,
  EMAIL = _svs$tickets_giftshop2.EMAIL,
  NAME = _svs$tickets_giftshop2.NAME,
  DATE = _svs$tickets_giftshop2.DATE,
  TIME = _svs$tickets_giftshop2.TIME,
  GREETING = _svs$tickets_giftshop2.GREETING;
const _svs$tickets_giftshop3 = svs.tickets_giftshop.constants.scrollIntoView,
  SMOOTH = _svs$tickets_giftshop3.SMOOTH,
  CENTER = _svs$tickets_giftshop3.CENTER;
const PREVIEW_ROUTE = svs.tickets_giftshop.constants.routes.PREVIEW_ROUTE;
const _svs$tickets_giftshop4 = svs.tickets_giftshop.gift.giftform.actions,
  inputChangeAction = _svs$tickets_giftshop4.inputChangeAction,
  receiverTypeChangeAction = _svs$tickets_giftshop4.receiverTypeChangeAction;
const setErrorAction = svs.tickets_giftshop.gift.giftform.cart.actions.setErrorAction;
const Reminder = svs.tur.Reminder;
const GiftForm = _ref => {
  let _ref$formData = _ref.formData,
    formData = _ref$formData === void 0 ? {} : _ref$formData,
    history = _ref.history,
    onInputChange = _ref.onInputChange,
    onReceiverTypeChange = _ref.onReceiverTypeChange,
    itemsInCartCount = _ref.itemsInCartCount,
    onCartError = _ref.onCartError;
  const cartRef = React.useRef();
  const personalRef = React.useRef();
  const receiverTypeRef = React.useRef();
  const dateRef = React.useRef();
  const ref = React.useRef();
  const isMobile = svs.core.detect.formfactor.mobile();
  const scrollOffsetY = React.useMemo(() => {
    var _getComputedStyle, _getComputedStyle2;
    const fixedTopContentHeight = parseInt((_getComputedStyle = getComputedStyle(document.documentElement)) === null || _getComputedStyle === void 0 ? void 0 : _getComputedStyle.getPropertyValue('--fixedTopContentHeight'), 10) || 0;
    const itemsMenuWrapperHeight = (isMobile ? 0 : parseInt((_getComputedStyle2 = getComputedStyle(document.documentElement)) === null || _getComputedStyle2 === void 0 ? void 0 : _getComputedStyle2.getPropertyValue('--itemsMenuWrapperHeight'), 10)) || 0;
    return fixedTopContentHeight - itemsMenuWrapperHeight;
  }, [isMobile]);
  const handlePreviewSubmit = (e, formData) => {
    e && e.preventDefault();
    const ops = {
      behavior: SMOOTH,
      block: CENTER
    };
    if (!itemsInCartCount) {
      onCartError && onCartError();
      cartRef.current.scrollIntoView(ops);
    } else if (!formData[NAME].isValid || !formData[GREETING].isValid) {
      personalRef.current.scrollIntoView(ops);
    } else if (formData[EMAIL] && !formData[EMAIL].isValid || formData[PHONE] && !formData[PHONE].isValid) {
      receiverTypeRef.current.scrollIntoView(ops);
    } else if (!formData[DATE].isValid || !formData[TIME].isValid) {
      receiverTypeRef.current.scrollIntoView(ops);
    } else {
      history && history.push(PREVIEW_ROUTE);
    }
  };
  const handleInputChange = _ref2 => {
    let _ref2$target = _ref2.target,
      value = _ref2$target.value,
      name = _ref2$target.name;
    onInputChange && onInputChange({
      field: name,
      value
    });
  };
  const handleReceiverTypeChange = value => {
    onReceiverTypeChange && onReceiverTypeChange({
      value
    });
  };
  return React.createElement("div", {
    className: "tg-forms-container",
    ref: ref
  }, React.createElement(Reminder, {
    ref: ref,
    scrollConfig: {
      yOffset: scrollOffsetY
    }
  }), React.createElement(Form, {
    className: "tg-forms relative col-xs-12 col-sm-10 col-md-8 col-lg-6",
    id: "tg-gift-form",
    onSubmit: handlePreviewSubmit
  }, React.createElement(PersonalInfo, {
    greeting: formData.greeting,
    name: formData.name,
    onInputChange: handleInputChange,
    personalGreeting: formData.personalGreeting,
    ref: personalRef
  }), React.createElement(ReceiverTypeInfo, {
    email: formData.email,
    onInputChange: handleInputChange,
    onReceiverTypeChange: handleReceiverTypeChange,
    phone: formData.phone,
    receiverType: formData.receiverType,
    ref: receiverTypeRef
  }), React.createElement(DateSelector, {
    date: formData.date,
    dateSelector: formData.dateSelector,
    nameDayName: formData.nameDayName,
    onInputChange: handleInputChange,
    ref: dateRef,
    time: formData.time
  }), React.createElement("input", {
    className: "hide",
    type: "submit"
  }), React.createElement(Cart, {
    ref: cartRef
  })));
};
const mapState = state => {
  const settings = state.settings,
    cart = state.cart;
  const targetCartState = cart[settings.branding] || {};
  return {
    formData: state.giftform,
    itemsInCartCount: targetCartState.count
  };
};
const mapDispatch = dispatch => ({
  onInputChange: _ref3 => {
    let field = _ref3.field,
      value = _ref3.value;
    return dispatch(inputChangeAction({
      field,
      value
    }));
  },
  onReceiverTypeChange: _ref4 => {
    let value = _ref4.value;
    return dispatch(receiverTypeChangeAction({
      value
    }));
  },
  onCartError: () => dispatch(setErrorAction())
});
svs.tickets_giftshop.gift.giftform.GiftForm = ReactRedux.connect(mapState, mapDispatch)(GiftForm);

 })(window);